import { DataFilter } from '@siclop/kstone-vue'

export class DesignSystemFilter extends DataFilter {
  organizationId?: number
  isDefault?: boolean
  isActive?: boolean

  constructor(data?: Partial<DesignSystemFilter>) {
    super(data)
    if (data) {
      this.organizationId = data.organizationId
      this.isDefault = data.isDefault
      this.isActive = data.isActive
    }
  }
}
